import TrustedShopsLogo from "../../icons/TrustedShops.svg";
import TrustedPilotLogo from "../../icons/TrustedPilot.svg";
import { translate } from "../../utils/translator";
import { clientConfig } from "../../config";
import { getTrustBadgeLocale, TrustProvider } from "./trustBadgeLocales";

// Uploaded asset is a single star, so the rating row repeats it five times.
const GOLDEN_STAR_URL = `${clientConfig.IMAGES_URL}uploads/general/trusted-shops-golden-star.svg`;

// V3 feature glyphs from the Figma badge, drawn white on the orange circle (24x24 grid).
const V3_FEATURE_GLYPHS = {
  moneyBack: (
    <>
      <path transform="translate(6 6)" fill="white" d="M10.3722 0.54175C10.0962 0.54175 9.87225 0.76575 9.87225 1.04175V1.4585C8.79825 0.522 7.4285 0 5.96875 0C2.6775 0 0 2.68725 0 5.99C0 6.266 0.224 6.49 0.5 6.49C0.776 6.49 1 6.266 1 5.99C1 3.2385 3.229 1 5.96875 1C7.1705 1 8.2995 1.4255 9.1895 2.18975H8.73125C8.45525 2.18975 8.23125 2.41375 8.23125 2.68975C8.23125 2.96575 8.45525 3.18975 8.73125 3.18975H10.3722C10.6482 3.18975 10.8722 2.96575 10.8722 2.68975V1.04175C10.8722 0.76575 10.6482 0.54175 10.3722 0.54175Z" />
      <path transform="translate(7.18 11.51)" fill="white" d="M10.3195 0C10.0435 0 9.8195 0.224 9.8195 0.5C9.8195 3.2515 7.5905 5.49 4.85075 5.49C3.663 5.49 2.546 5.075 1.661 4.3275H2.14125C2.41725 4.3275 2.64125 4.1035 2.64125 3.8275C2.64125 3.5515 2.41725 3.3275 2.14125 3.3275H0.5C0.224 3.3275 0 3.5515 0 3.82775V5.47575C0 5.75175 0.224 5.97575 0.5 5.97575C0.776 5.97575 1 5.75175 1 5.47575V5.07825C2.06575 5.9855 3.415 6.49 4.85075 6.49C8.142 6.49 10.8195 3.80275 10.8195 0.5C10.8195 0.224 10.5955 0 10.3195 0Z" />
    </>
  ),
  secureData: (
    <g stroke="white" strokeLinecap="round" strokeLinejoin="round">
      <path d="M16.4725 6.33283C15.211 5.70515 13.6673 5.33594 12 5.33594C10.3327 5.33594 8.789 5.70515 7.52744 6.33284C6.90879 6.64064 6.59946 6.79455 6.29973 7.27846C6 7.76238 6 8.23092 6 9.16803V11.494C6 15.2829 9.02824 17.3895 10.782 18.2918C11.2711 18.5435 11.5157 18.6693 12 18.6693C12.4843 18.6693 12.7289 18.5435 13.2179 18.2918C14.9717 17.3895 18 15.2829 18 11.494V9.16804C18 8.23093 18 7.76238 17.7003 7.27846C17.4005 6.79455 17.0912 6.64064 16.4725 6.33283Z" />
      <path d="M11.9987 9.9974V10.664M11.332 10.3307C11.332 10.5075 11.4023 10.6771 11.5273 10.8021C11.6523 10.9272 11.8219 10.9974 11.9987 10.9974C12.1755 10.9974 12.3451 10.9272 12.4701 10.8021C12.5951 10.6771 12.6654 10.5075 12.6654 10.3307C12.6654 10.1539 12.5951 9.98435 12.4701 9.85933C12.3451 9.7343 12.1755 9.66406 11.9987 9.66406C11.8219 9.66406 11.6523 9.7343 11.5273 9.85933C11.4023 9.98435 11.332 10.1539 11.332 10.3307Z" />
      <path d="M12.5 13.3255H11.5L12 10.9922L12.5 13.3255Z" />
    </g>
  ),
  discreetPackaging: (
    <g stroke="white" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 18.6641C11.4546 18.6641 10.9337 18.444 9.89187 18.004L9.89129 18.0037C7.29709 16.9079 6 16.3599 6 15.4383V8.66406M12 18.6641C12.5454 18.6641 13.0663 18.444 14.1081 18.004L14.1087 18.0037C16.7029 16.9079 18 16.3599 18 15.4383V8.66406M12 18.6641V11.5673" />
      <path d="M9.55061 10.4635L7.60315 9.52117C6.53438 9.004 6 8.74542 6 8.33594C6 7.92645 6.53438 7.66787 7.60315 7.1507L9.55061 6.20835C10.7525 5.62674 11.3535 5.33594 12 5.33594C12.6465 5.33594 13.2475 5.62674 14.4494 6.20835L16.3969 7.1507C17.4656 7.66787 18 7.92645 18 8.33594C18 8.74542 17.4656 9.004 16.3969 9.52117L14.4494 10.4635C13.2475 11.0451 12.6465 11.3359 12 11.3359C11.3535 11.3359 10.7525 11.0451 9.55061 10.4635Z" />
      <path d="M8 12L9.33333 12.6667" />
      <path d="M15.3346 6.66406L8.66797 9.9974" />
    </g>
  ),
};

const V3FeatureGlyph = ({ glyph }: { glyph: keyof typeof V3_FEATURE_GLYPHS }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">{V3_FEATURE_GLYPHS[glyph]}</svg>
);

const featureIconClass = "w-[24px] h-[24px] shrink-0 rounded-full flex items-center justify-center";
const featureIconStyle = { background: "linear-gradient(90deg, #F59200 0%, #FFBB29 100%)" };
// Mobile features share the row equally and a long word widens its own feature instead of running into the next icon.
const featureLabelClass = "leading-[1.2] text-[11px] md:text-[14px] max-[360px]:w-auto md:shrink-0 text-[#616975] font-normal font-roboto";

// One design for every country; per-country values come from trustBadgeLocales.tsx and the payment translations.
export default function TrustBadgeV3({ className, country, language, provider }: { className: string, country: string, language: string, provider?: TrustProvider }) {
  const locale = getTrustBadgeLocale(country);
  const t = (key: string) => translate(language, "payment", `trustedShopsPilot/${key}`);
  const logo = (provider ?? locale.provider) === "trustpilot" ? TrustedPilotLogo : TrustedShopsLogo;

  return (
    <div id="trusted-shops-badge" className={`pt-[17px] px-[12px] pb-[12px] md:p-[16px] bg-white rounded-[13px] flex flex-col relative overflow-hidden ${className}`}>

      {/* Header Section */}
      <div id="trusted-shops-header" className="flex items-center justify-between gap-x-2 mb-[20px] md:mb-[16px] max-[370px]:flex-col">

        <div id="trusted-shops-info" className="flex items-center gap-3">
          {/* Product call: mobile keeps Figma's mid-word title wrap, desktop keeps it on one line. */}
          <div id="trusted-shops-details" className="flex items-center gap-1">
            <img id="trusted-shops-logo" src={logo} alt="title" className="w-[45px] h-[44px] max-[380px]:w-[40px] max-[380px]:h-[39px] shrink-0" />
            <div className="flex flex-col gap-[2px] w-[130px] h-[49.852px]">
              <h3 id="trusted-shops-title" className="m-0 font-poppins font-medium text-[18px] leading-[1.3] tracking-[0.027px] text-black break-words md:whitespace-nowrap">{t(`title_${locale.code}`)}</h3>
              <div id="trusted-shops-rating" className="flex items-center justify-between">
                <span id="trusted-shops-stars" className="flex items-center gap-[1.2px]" role="img" aria-label="stars">
                  {[0, 1, 2, 3, 4].map((i) => (
                    <img key={i} src={GOLDEN_STAR_URL} alt="" className="w-[17.85px] h-[17.85px]" />
                  ))}
                </span>
                <span id="trusted-shops-score" className="font-roboto text-[12px] md:text-[14px] md:font-medium leading-[18px] md:leading-[18px] text-[#5f5f5f]">{t("score")}</span>
              </div>
            </div>
          </div>
        </div>

        <div id="trusted-shops-stats">
          <div
            id="treatments-counter"
            className="flex flex-col items-start gap-1 px-2 md:px-4 py-1 rounded-[12.772px] border-0 border-t-[0.851px] border-solid border-transparent shadow-[0_3.406px_2.597px_rgba(0,0,0,0.08)]"
            style={{ background: `linear-gradient(#fdfcf9, #fdfcf9) padding-box, ${locale.boxBorder} border-box` }}
          >
            {/* A count that does not fit on one line wraps its label instead of splitting the number. */}
            <span className={`flex flex-wrap items-center gap-x-1 ${locale.stackCount ? "max-md:flex-col max-md:items-start" : ""}`}>
              <span id="treatments-number" className="whitespace-nowrap text-base font-normal md:font-medium font-prompt text-[#33363d] leading-[1.2]">{t(`count_${locale.code}`)}</span>
              <span className="text-xs md:text-base font-semibold font-assistant leading-[1.3] md:leading-[1.3] text-transparent" style={{ backgroundImage: "linear-gradient(180deg, #08080a, #414557)", WebkitBackgroundClip: "text", backgroundClip: "text" }}>{t("label_1")}</span>
            </span>
            <span id="treatments-location" className="flex items-center gap-1 text-xs md:text-sm font-normal font-roboto text-[#08080a] leading-[18px] md:leading-[18px]">
              <span id="treatments-flag" aria-hidden="true" className="relative w-4 h-[15.652px] shrink-0 overflow-hidden rounded-[27.826px] bg-white">
                {locale.flag}
              </span>
              {t(`location_${locale.code}`)}
            </span>
          </div>
        </div>

      </div>


      {/* Features Section */}
      <div id="trusted-shops-features" className="flex items-center justify-between gap-2 md:gap-0 max-[360px]:flex-col max-[360px]:items-start max-[360px]:gap-2">

        <div id="money-back-feature" className="flex items-center gap-[6px] flex-1 md:flex-none md:w-[109px]">
          <div id="money-back-icon-container" className={featureIconClass} style={featureIconStyle}>
            <V3FeatureGlyph glyph="moneyBack" />
          </div>
          <span id="money-back-line" className={`${featureLabelClass} md:w-[79px]`}>{t("label_3")}</span>
        </div>

        <div id="secure-data-feature" className="flex items-center gap-[6px] flex-1 md:flex-none">
          <div id="secure-data-icon-container" className={featureIconClass} style={featureIconStyle}>
            <V3FeatureGlyph glyph="secureData" />
          </div>
          <span id="secure-data-line" className={`${featureLabelClass} md:w-[130px]`}>{t("label_4")}</span>
        </div>

        <div id="discreet-packaging-feature" className="flex items-center gap-[6px] flex-1 md:flex-none md:justify-end">
          <div id="discreet-packaging-icon-container" className={featureIconClass} style={featureIconStyle}>
            <V3FeatureGlyph glyph="discreetPackaging" />
          </div>
          <span id="discreet-packaging-line" className={`${featureLabelClass} md:w-[82px]`}>{t("label_5")}</span>
        </div>

      </div>
    </div>
  );
}
